<dynamic-material-form
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange($event)"
  (matEvent)="onCustomEvent($event, null, true)"
  data-test="gsm-zahlungsempfaenger_form"
>
</dynamic-material-form>
